/**
 * 図解を編ごとに束ねた索引。**自動生成**なので手で編集しない。
 *   packages/figures で bun run build
 *
 * 並びと号数は demo.html と同じ計算から出しているので、片方だけずれることはない。
 * タイトル・説明・寸法は figure-meta.ts 側が持つ。
 */
export interface FigureGroup {
  /** 編の名前。例 "Python 基礎編" */
  label: string;
  items: { id: string; no: number }[];
}

/** 全 1405 枚 / 12 編 */
export const FIGURE_GROUPS: FigureGroup[] = [
  {
    label: "Python 基礎編",
    items: [
      { id: "array-index", no: 1 },
      { id: "loop-range", no: 2 },
      { id: "variable-assign", no: 3 },
      { id: "reference-copy", no: 4 },
      { id: "condition-route", no: 5 },
      { id: "function-return", no: 6 },
      { id: "scope-inside", no: 7 },
      { id: "type-error", no: 8 },
      { id: "dict-key", no: 9 },
      { id: "while-infinite", no: 10 },
      { id: "loop-nested", no: 11 },
      { id: "slice-range", no: 12 },
      { id: "string-repeat", no: 13 },
      { id: "list-append", no: 14 },
      { id: "zip-pair", no: 15 },
      { id: "try-except", no: 16 },
      { id: "recursion-stack", no: 17 },
      { id: "default-arg", no: 18 },
      { id: "mutable-tuple", no: 19 },
      { id: "f-string", no: 20 },
    ],
  },
  {
    label: "データ構造とアルゴリズム編",
    items: [
      { id: "stack-queue", no: 21 },
      { id: "binary-search", no: 22 },
      { id: "bubble-sort", no: 23 },
      { id: "quick-sort", no: 24 },
      { id: "hash-bucket", no: 25 },
      { id: "linked-list", no: 26 },
      { id: "tree-search", no: 27 },
      { id: "big-o", no: 28 },
      { id: "prefix-sum", no: 29 },
      { id: "sliding-window", no: 30 },
    ],
  },
  {
    label: "Web とデータ表現編",
    items: [
      { id: "http-journey", no: 31 },
      { id: "get-post", no: 32 },
      { id: "cookie-session", no: 33 },
      { id: "sync-async", no: 34 },
      { id: "cache-stale", no: 35 },
      { id: "binary-decimal", no: 36 },
      { id: "encoding-mojibake", no: 37 },
      { id: "ip-port", no: 38 },
      { id: "public-key", no: 39 },
      { id: "url-parts", no: 40 },
    ],
  },
  {
    label: "SQL 編",
    items: [
      { id: "db-lost-update", no: 41 },
      { id: "db-split-tables", no: 42 },
      { id: "sql-row-column", no: 43 },
      { id: "sql-where", no: 44 },
      { id: "sql-where-cut", no: 45 },
      { id: "sql-where-strcmp", no: 46 },
      { id: "sql-join", no: 47 },
      { id: "sql-groupby", no: 48 },
      { id: "sql-index", no: 49 },
      { id: "sql-null", no: 50 },
    ],
  },
  {
    label: "生成 AI 編",
    items: [
      { id: "llm-token", no: 51 },
      { id: "llm-temperature", no: 52 },
      { id: "llm-context", no: 53 },
      { id: "prompt-template", no: 54 },
      { id: "rag-flow", no: 55 },
      { id: "embedding-space", no: 56 },
      { id: "hallucination", no: 57 },
      { id: "few-shot", no: 58 },
      { id: "api-request", no: 59 },
      { id: "system-prompt", no: 60 },
    ],
  },
  {
    label: "デバッグ・実務編",
    items: [
      { id: "traceback-read", no: 61 },
      { id: "print-debug", no: 62 },
      { id: "watch-variable", no: 63 },
      { id: "off-by-one", no: 64 },
      { id: "ai-code-review", no: 65 },
    ],
  },
  {
    label: "Git・チーム開発編",
    items: [
      { id: "git-commit", no: 66 },
      { id: "git-branch", no: 67 },
      { id: "git-conflict", no: 68 },
      { id: "git-sync", no: 69 },
      { id: "git-ignore", no: 70 },
      { id: "git-recover", no: 71 },
    ],
  },
  {
    label: "AI 実務編",
    items: [
      { id: "agent-loop", no: 72 },
      { id: "tool-use", no: 73 },
      { id: "task-decompose", no: 74 },
      { id: "streaming", no: 75 },
      { id: "output-validate", no: 76 },
      { id: "context-design", no: 77 },
      { id: "regex-match", no: 78 },
      { id: "csv-pitfall", no: 79 },
      { id: "datetime-trap", no: 80 },
    ],
  },
  {
    label: "Linux・シェル編",
    items: [
      { id: "dir-tree", no: 81 },
      { id: "path-abs-rel", no: 82 },
      { id: "permission-rwx", no: 83 },
      { id: "pipe-redirect", no: 84 },
      { id: "process-kill", no: 85 },
      { id: "env-path", no: 86 },
      { id: "sudo-root", no: 87 },
      { id: "ssh-remote", no: 88 },
    ],
  },
  {
    label: "ネットワーク編",
    items: [
      { id: "packet-split", no: 89 },
      { id: "tcp-udp", no: 90 },
      { id: "dns-hierarchy", no: 91 },
      { id: "ping-latency", no: 92 },
      { id: "ping-floor", no: 93 },
      { id: "ping-near", no: 94 },
      { id: "ping-far", no: 95 },
      { id: "router-hop", no: 96 },
      { id: "nat-private-ip", no: 97 },
      { id: "firewall", no: 98 },
    ],
  },
  {
    label: "コンピュータの仕組み編",
    items: [
      { id: "compile-translate", no: 99 },
      { id: "compiler-interpreter", no: 100 },
      { id: "cpu-cycle", no: 101 },
      { id: "memory-address", no: 102 },
      { id: "memory-hierarchy", no: 103 },
      { id: "ram-storage", no: 104 },
      { id: "stack-heap", no: 105 },
      { id: "garbage-collect", no: 106 },
      { id: "float-error", no: 107 },
      { id: "all-is-numbers", no: 108 },
      { id: "os-multitask", no: 109 },
      { id: "abstraction-layers", no: 110 },
    ],
  },
  {
    label: "番外 (号数なし)",
    items: [
      { id: "bit-shift", no: 111 },
      { id: "endian-byte-order", no: 112 },
      { id: "ai-data-privacy", no: 113 },
      { id: "ai-knowledge-cutoff", no: 114 },
      { id: "ai-model-tradeoff", no: 115 },
      { id: "prompt-specificity", no: 116 },
      { id: "tone-dial", no: 117 },
      { id: "summary-compression", no: 118 },
      { id: "chat-data-retention", no: 119 },
      { id: "chat-edit-branch", no: 120 },
      { id: "idea-quantity", no: 121 },
      { id: "draft-revision", no: 122 },
      { id: "output-format", no: 123 },
      { id: "subscription-route", no: 124 },
      { id: "copyright-similarity", no: 125 },
      { id: "image-prompt-parts", no: 126 },
      { id: "ts-catch-typo", no: 127 },
      { id: "ts-compile-strip", no: 128 },
      { id: "ts-param-guard", no: 129 },
      { id: "ts-hover-infer", no: 130 },
      { id: "ts-number-string-plus", no: 131 },
      { id: "ts-array-type-gate", no: 132 },
      { id: "ts-object-shape-diff", no: 133 },
      { id: "ts-any-contagion", no: 134 },
      { id: "ts-null-check-gate", no: 135 },
      { id: "ts-alias-fanout", no: 136 },
      { id: "ts-return-type-bracket", no: 137 },
      { id: "sql-foreign-key", no: 138 },
      { id: "promise-state", no: 139 },
      { id: "console-log-return", no: 140 },
      { id: "string-plus-number", no: 141 },
      { id: "let-const-reassign", no: 142 },
      { id: "truthy-falsy", no: 143 },
      { id: "equality-coercion", no: 144 },
      { id: "ternary-swap", no: 145 },
      { id: "if-two-ways", no: 146 },
      { id: "elseif-order", no: 147 },
      { id: "switch-fallthrough", no: 148 },
      { id: "fizzbuzz-order", no: 149 },
      { id: "array-index-js", no: 150 },
      { id: "for-three-parts", no: 151 },
      { id: "for-of-vs-index", no: 152 },
      { id: "while-condition", no: 153 },
      { id: "break-continue", no: 154 },
      { id: "function-in-out", no: 155 },
      { id: "callback-pass", no: 156 },
      { id: "block-scope", no: 157 },
      { id: "const-reassign-vs-mutate", no: 158 },
      { id: "optional-chain", no: 159 },
      { id: "queryselector-one-all", no: 160 },
      { id: "classlist-toggle", no: 161 },
      { id: "create-append", no: 162 },
      { id: "addeventlistener", no: 163 },
      { id: "input-value-string", no: 164 },
      { id: "arith-precedence", no: 165 },
      { id: "typeof-table", no: 166 },
      { id: "number-string-convert", no: 167 },
      { id: "null-undefined", no: 168 },
      { id: "template-literal", no: 169 },
      { id: "short-circuit", no: 170 },
      { id: "nullish-vs-or", no: 171 },
      { id: "nested-vs-flat", no: 172 },
      { id: "push-pop-shift", no: 173 },
      { id: "foreach-no-break", no: 174 },
      { id: "find-vs-includes", no: 175 },
      { id: "arrow-shorthand", no: 176 },
      { id: "default-param", no: 177 },
      { id: "guard-clause", no: 178 },
      { id: "object-key-value", no: 179 },
      { id: "return-object", no: 180 },
      { id: "destructuring", no: 181 },
      { id: "spread-copy", no: 182 },
      { id: "render-list", no: 183 },
      { id: "event-target", no: 184 },
      { id: "preventdefault", no: 185 },
      { id: "localstorage-json", no: 186 },
      { id: "script-defer", no: 187 },
      { id: "error-three-parts", no: 188 },
      { id: "py-arith-order", no: 189 },
      { id: "py-bool-none", no: 190 },
      { id: "py-break-continue", no: 191 },
      { id: "py-chained-priority", no: 192 },
      { id: "py-comparison", no: 193 },
      { id: "py-csv-line", no: 194 },
      { id: "py-def-shape", no: 195 },
      { id: "py-default-or", no: 196 },
      { id: "py-dict-loop", no: 197 },
      { id: "py-divmod", no: 198 },
      { id: "py-enumerate", no: 199 },
      { id: "py-exec-order", no: 200 },
      { id: "py-file-read", no: 201 },
      { id: "py-file-write", no: 202 },
      { id: "py-fizzbuzz-order", no: 203 },
      { id: "py-for-sum", no: 204 },
      { id: "py-if-two-ways", no: 205 },
      { id: "py-in-operator", no: 206 },
      { id: "py-keyword-args", no: 207 },
      { id: "py-lambda", no: 208 },
      { id: "py-logical-ops", no: 209 },
      { id: "py-match-branch", no: 210 },
      { id: "py-modulo", no: 211 },
      { id: "py-multiple-return", no: 212 },
      { id: "py-nested-if", no: 213 },
      { id: "py-print-args", no: 214 },
      { id: "py-str-cast", no: 215 },
      { id: "py-ternary-py", no: 216 },
      { id: "py-type-check", no: 217 },
      { id: "py-with-close", no: 218 },
      { id: "py-exception-types", no: 219 },
      { id: "py-input-str", no: 220 },
      { id: "py-list-comp", no: 221 },
      { id: "py-set-dedup", no: 222 },
      { id: "py-sort-key", no: 223 },
      { id: "jsx-is-js", no: 224 },
      { id: "jsx-one-root", no: 225 },
      { id: "jsx-expression", no: 226 },
      { id: "component-call", no: 227 },
      { id: "props-one-way", no: 228 },
      { id: "children-slot", no: 229 },
      { id: "why-state", no: 230 },
      { id: "usestate-pair", no: 231 },
      { id: "set-triggers-render", no: 232 },
      { id: "state-object-spread", no: 233 },
      { id: "state-array-push", no: 234 },
      { id: "rerender-three-steps", no: 235 },
      { id: "handler-not-called", no: 236 },
      { id: "react-event-object", no: 237 },
      { id: "controlled-input", no: 238 },
      { id: "uncontrolled-broken", no: 239 },
      { id: "form-preventdefault-react", no: 240 },
      { id: "validation-gate", no: 241 },
      { id: "map-to-elements", no: 242 },
      { id: "key-identity", no: 243 },
      { id: "and-render", no: 244 },
      { id: "ternary-render", no: 245 },
      { id: "empty-state", no: 246 },
      { id: "filter-then-map", no: 247 },
      { id: "effect-timing", no: 248 },
      { id: "deps-empty-vs-none", no: 249 },
      { id: "deps-value", no: 250 },
      { id: "effect-cleanup", no: 251 },
      { id: "component-tree", no: 252 },
      { id: "lifting-state", no: 253 },
      { id: "props-drilling", no: 254 },
      { id: "declarative-vs-imperative", no: 255 },
      { id: "strict-mode-catch", no: 256 },
      { id: "data-vs-view", no: 257 },
      { id: "map-shape-change", no: 258 },
      { id: "filter-vs-find", no: 259 },
      { id: "reduce-accumulate", no: 260 },
      { id: "sort-compare-sign", no: 261 },
      { id: "group-by-bucket", no: 262 },
      { id: "pipeline-order", no: 263 },
      { id: "closure-capture", no: 264 },
      { id: "factory-two-instances", no: 265 },
      { id: "function-returns-function", no: 266 },
      { id: "pure-vs-side-effect", no: 267 },
      { id: "destructure-rename-default", no: 268 },
      { id: "spread-vs-rest", no: 269 },
      { id: "keys-values-entries", no: 270 },
      { id: "class-blueprint-instances", no: 271 },
      { id: "private-field-gate", no: 272 },
      { id: "super-chain", no: 273 },
      { id: "static-vs-instance", no: 274 },
      { id: "try-catch-finally-order", no: 275 },
      { id: "custom-error-name", no: 276 },
      { id: "error-to-screen", no: 277 },
      { id: "regexp-anchor-gate", no: 278 },
      { id: "capture-group-swap", no: 279 },
      { id: "await-pauses-here", no: 280 },
      { id: "all-vs-sequential", no: 281 },
      { id: "async-try-catch-reach", no: 282 },
      { id: "fetch-then-paint", no: 283 },
      { id: "response-ok-gate", no: 284 },
      { id: "post-request-parts", no: 285 },
      { id: "module-scope-split", no: 286 },
      { id: "named-vs-default", no: 287 },
      { id: "props-type-shape", no: 288 },
      { id: "usestate-generic", no: 289 },
      { id: "event-handler-type", no: 290 },
      { id: "children-react-node", no: 291 },
      { id: "mock-api-swap", no: 292 },
      { id: "effect-fetch-once", no: 293 },
      { id: "response-type-cast", no: 294 },
      { id: "deps-refetch", no: 295 },
      { id: "cleanup-race", no: 296 },
      { id: "post-then-refresh", no: 297 },
      { id: "three-states-union", no: 298 },
      { id: "loading-skeleton", no: 299 },
      { id: "error-retry", no: 300 },
      { id: "empty-vs-loading", no: 301 },
      { id: "submit-disabled", no: 302 },
      { id: "hook-extract", no: 303 },
      { id: "useitems-return", no: 304 },
      { id: "useform-binding", no: 305 },
      { id: "hook-rules-order", no: 306 },
      { id: "hook-generic-type", no: 307 },
      { id: "context-provider-scope", no: 308 },
      { id: "usecontext-read", no: 309 },
      { id: "theme-switch-all", no: 310 },
      { id: "user-context-gate", no: 311 },
      { id: "setstate-scatter", no: 312 },
      { id: "reducer-three-parts", no: 313 },
      { id: "action-union", no: 314 },
      { id: "cart-quantity", no: 315 },
      { id: "reducer-vs-state", no: 316 },
      { id: "spa-no-reload", no: 317 },
      { id: "route-path-match", no: 318 },
      { id: "link-vs-navigate", no: 319 },
      { id: "url-param-read", no: 320 },
      { id: "search-params-share", no: 321 },
      { id: "route-fallback", no: 322 },
      { id: "view-vs-logic", no: 323 },
      { id: "composition-slots", no: 324 },
      { id: "folder-by-feature", no: 325 },
      { id: "spa-first-paint", no: 326 },
      { id: "nextjs-layers", no: 327 },
      { id: "app-dir-tree", no: 328 },
      { id: "react-vs-next-line", no: 329 },
      { id: "file-becomes-url", no: 330 },
      { id: "page-file-required", no: 331 },
      { id: "nested-url-depth", no: 332 },
      { id: "link-prefetch", no: 333 },
      { id: "pathname-hook", no: 334 },
      { id: "loading-file-swap", no: 335 },
      { id: "server-client-split", no: 336 },
      { id: "rsc-no-js", no: 337 },
      { id: "use-client-boundary", no: 338 },
      { id: "where-to-put", no: 339 },
      { id: "children-across-boundary", no: 340 },
      { id: "boundary-leaf", no: 341 },
      { id: "route-handler-file", no: 342 },
      { id: "get-returns-json", no: 343 },
      { id: "post-body-parse", no: 344 },
      { id: "server-action-no-api", no: 345 },
      { id: "form-action-flow", no: 346 },
      { id: "layout-wraps-page", no: 347 },
      { id: "header-not-remount", no: 348 },
      { id: "nested-layout-stack", no: 349 },
      { id: "active-link-match", no: 350 },
      { id: "css-scope-next", no: 351 },
      { id: "server-fetch-no-effect", no: 352 },
      { id: "async-component-await", no: 353 },
      { id: "dynamic-segment", no: 354 },
      { id: "params-shape", no: 355 },
      { id: "notfound-throw", no: 356 },
      { id: "cache-hit-miss", no: 357 },
      { id: "search-server", no: 358 },
      { id: "metadata-to-head", no: 359 },
      { id: "generate-metadata-param", no: 360 },
      { id: "ogp-card-parts", no: 361 },
      { id: "image-size-swap", no: 362 },
      { id: "font-swap-shift", no: 363 },
      { id: "build-output-kinds", no: 364 },
      { id: "deploy-managed-parts", no: 365 },
      { id: "deploy-self-parts", no: 366 },
      { id: "optional-param-gate", no: 367 },
      { id: "default-infers-type", no: 368 },
      { id: "void-return", no: 369 },
      { id: "arrow-type-position", no: 370 },
      { id: "callback-signature", no: 371 },
      { id: "interface-shape", no: 372 },
      { id: "optional-prop-check", no: 373 },
      { id: "readonly-assign", no: 374 },
      { id: "interface-vs-type", no: 375 },
      { id: "nested-type-path", no: 376 },
      { id: "array-of-objects-type", no: 377 },
      { id: "union-two-types", no: 378 },
      { id: "literal-narrow-set", no: 379 },
      { id: "status-union-states", no: 380 },
      { id: "typeof-narrow", no: 381 },
      { id: "in-narrow", no: 382 },
      { id: "union-switch-render", no: 383 },
      { id: "why-generics-any", no: 384 },
      { id: "generic-t-flow", no: 385 },
      { id: "generic-array-return", no: 386 },
      { id: "generic-constraint-gate", no: 387 },
      { id: "builtin-generics", no: 388 },
      { id: "tsconfig-strict-gate", no: 389 },
      { id: "migrate-order", no: 390 },
      { id: "migrate-data-first", no: 391 },
      { id: "migrate-utils-signature", no: 392 },
      { id: "fix-error-order", no: 393 },
      { id: "dom-type-cast", no: 394 },
      { id: "import-namespace", no: 395 },
      { id: "from-import-alias", no: 396 },
      { id: "stdlib-pick", no: 397 },
      { id: "datetime-parts", no: 398 },
      { id: "my-module-path", no: 399 },
      { id: "tuple-vs-list", no: 400 },
      { id: "immutable-rebind", no: 401 },
      { id: "dict-get-default", no: 402 },
      { id: "defaultdict-auto", no: 403 },
      { id: "counter-tally", no: 404 },
      { id: "nested-access-path", no: 405 },
      { id: "listcomp-filter", no: 406 },
      { id: "listcomp-ifelse-position", no: 407 },
      { id: "dictcomp-pairs", no: 408 },
      { id: "setcomp-dedup", no: 409 },
      { id: "genexp-lazy", no: 410 },
      { id: "func-as-value", no: 411 },
      { id: "map-shape", no: 412 },
      { id: "filter-count", no: 413 },
      { id: "sorted-key-order", no: 414 },
      { id: "reduce-fold", no: 415 },
      { id: "any-all-gate", no: 416 },
      { id: "exception-tree", no: 417 },
      { id: "raise-stops-here", no: 418 },
      { id: "custom-exception-catch", no: 419 },
      { id: "finally-else-order", no: 420 },
      { id: "assert-precondition", no: 421 },
      { id: "csv-reader-rows", no: 422 },
      { id: "json-dump-shape", no: 423 },
      { id: "json-load-types", no: 424 },
      { id: "pathlib-join", no: 425 },
      { id: "encoding-mismatch", no: 426 },
      { id: "class-instance-py", no: 427 },
      { id: "init-self-assign", no: 428 },
      { id: "method-self-first", no: 429 },
      { id: "str-repr-diff", no: 430 },
      { id: "class-var-shared", no: 431 },
      { id: "dataclass-boilerplate", no: 432 },
      { id: "objects-in-comprehension", no: 433 },
      { id: "sql-pk-null", no: 434 },
      { id: "sql-select-columns", no: 435 },
      { id: "sql-order-by-tiebreak", no: 436 },
      { id: "sql-limit-offset-window", no: 437 },
      { id: "sql-date-range", no: 438 },
      { id: "sql-aggregate-five", no: 439 },
      { id: "sql-arith-alias", no: 440 },
      { id: "sql-case-branch", no: 441 },
      { id: "sql-distinct-dedup", no: 442 },
      { id: "sql-string-funcs", no: 443 },
      { id: "sql-having-vs-where", no: 444 },
      { id: "sql-execution-order", no: 445 },
      { id: "sql-why-join", no: 446 },
      { id: "sql-outer-join", no: 447 },
      { id: "sql-multi-join", no: 448 },
      { id: "sql-self-join", no: 449 },
      { id: "sql-set-ops", no: 450 },
      { id: "sql-subquery-idea", no: 451 },
      { id: "sql-subquery-where", no: 452 },
      { id: "sql-subquery-from", no: 453 },
      { id: "sql-subquery-select", no: 454 },
      { id: "sql-cte-with", no: 455 },
      { id: "sql-create-table", no: 456 },
      { id: "sql-data-types", no: 457 },
      { id: "sql-soft-delete", no: 458 },
      { id: "sql-alter-table", no: 459 },
      { id: "sql-constraints", no: 460 },
      { id: "sql-truncate-drop", no: 461 },
      { id: "sql-fk-constraint", no: 462 },
      { id: "sql-fk-policies", no: 463 },
      { id: "sql-fk-actions", no: 464 },
      { id: "sql-logical-fk", no: 465 },
      { id: "sql-modeling-idea", no: 466 },
      { id: "sql-er-diagram", no: 467 },
      { id: "sql-entity-attribute", no: 468 },
      { id: "sql-cardinality", no: 469 },
      { id: "sql-many-to-many", no: 470 },
      { id: "sql-2nf", no: 471 },
      { id: "sql-3nf", no: 472 },
      { id: "sql-denormalize", no: 473 },
      { id: "sql-physical-design", no: 474 },
      { id: "sql-naming", no: 475 },
      { id: "sql-index-btree", no: 476 },
      { id: "sql-create-index", no: 477 },
      { id: "sql-index-tradeoff", no: 478 },
      { id: "dbd-redundant-fact", no: 479 },
      { id: "dbd-three-passes", no: 480 },
      { id: "dbd-noun-sieve", no: 481 },
      { id: "dbd-attribute-fill", no: 482 },
      { id: "dbd-anomaly-three", no: 483 },
      { id: "dbd-er-line-to-ddl", no: 484 },
      { id: "dbd-both-directions", no: 485 },
      { id: "dbd-fk-which-side", no: 486 },
      { id: "dbd-junction-split", no: 487 },
      { id: "dbd-symbol-to-ddl", no: 488 },
      { id: "dbd-1nf-cell-split", no: 489 },
      { id: "dbd-2nf-find-steps", no: 490 },
      { id: "dbd-3nf-store-chain", no: 491 },
      { id: "dbd-normalize-steps", no: 492 },
      { id: "dbd-denorm-order", no: 493 },
      { id: "dbd-surrogate-natural", no: 494 },
      { id: "dbd-composite-key", no: 495 },
      { id: "dbd-orphan-count", no: 496 },
      { id: "dbd-check-unique", no: 497 },
      { id: "dbd-null-spread", no: 498 },
      { id: "dbd-naming-rules", no: 499 },
      { id: "dbd-type-money", no: 500 },
      { id: "dbd-audit-columns", no: 501 },
      { id: "dbd-create-order", no: 502 },
      { id: "dbd-index-scan-cost", no: 503 },
      { id: "dbd-where-to-index", no: 504 },
      { id: "dbd-composite-leftmost", no: 505 },
      { id: "dbd-index-func-blind", no: 506 },
      { id: "dbd-explain-read", no: 507 },
      { id: "dbd-index-write-cost", no: 508 },
      { id: "dbd-junction-attribute", no: 509 },
      { id: "dbd-review-checklist", no: 510 },
      { id: "dbd-coupon-index", no: 511 },
      { id: "jv-println-lines", no: 512 },
      { id: "jv-string-build", no: 513 },
      { id: "jv-comment-scope", no: 514 },
      { id: "jv-var-box", no: 515 },
      { id: "jv-int-double", no: 516 },
      { id: "jv-int-division", no: 517 },
      { id: "jv-tax-round", no: 518 },
      { id: "jv-increment-pos", no: 519 },
      { id: "jv-compare-ops", no: 520 },
      { id: "jv-short-circuit", no: 521 },
      { id: "jv-op-priority", no: 522 },
      { id: "jv-plus-two-jobs", no: 523 },
      { id: "jv-cast-cut", no: 524 },
      { id: "jv-if-block", no: 525 },
      { id: "jv-if-else-split", no: 526 },
      { id: "jv-elseif-order", no: 527 },
      { id: "jv-grade-bands", no: 528 },
      { id: "jv-leap-year", no: 529 },
      { id: "jv-switch-break", no: 530 },
      { id: "jv-ternary-value", no: 531 },
      { id: "jv-janken-pairs", no: 532 },
      { id: "jv-fizzbuzz-judge", no: 533 },
      { id: "jv-for-three-parts", no: 534 },
      { id: "jv-sum-accumulate", no: 535 },
      { id: "jv-multiplication-row", no: 536 },
      { id: "jv-while-condition", no: 537 },
      { id: "jv-countdown", no: 538 },
      { id: "jv-do-while-once", no: 539 },
      { id: "jv-nested-loop-grid", no: 540 },
      { id: "jv-break-continue", no: 541 },
      { id: "jv-fizzbuzz-loop", no: 542 },
      { id: "jv-method-shape", no: 543 },
      { id: "jv-arg-copy", no: 544 },
      { id: "jv-return-stops", no: 545 },
      { id: "jv-args-order", no: 546 },
      { id: "jv-overload-pick", no: 547 },
      { id: "jv-bmi-method", no: 548 },
      { id: "jv-array-new", no: 549 },
      { id: "jv-array-walk", no: 550 },
      { id: "jv-array-sum", no: 551 },
      { id: "jv-array-avg-int", no: 552 },
      { id: "jv-linear-search", no: 553 },
      { id: "jv-foreach-noindex", no: 554 },
      { id: "jv-class-blueprint", no: 555 },
      { id: "jv-field-per-instance", no: 556 },
      { id: "jv-method-uses-field", no: 557 },
      { id: "jv-new-instance", no: 558 },
      { id: "jv-constructor-init", no: 559 },
      { id: "jv-this-shadow", no: 560 },
      { id: "jv-private-gate", no: 561 },
      { id: "jv-person-instances", no: 562 },
      { id: "jv-product-tax", no: 563 },
      { id: "jv-balance-state", no: 564 },
      { id: "jv-tostring-print", no: 565 },
      { id: "ji-list-vs-array", no: 566 },
      { id: "ji-list-iterate", no: 567 },
      { id: "ji-list-remove-shift", no: 568 },
      { id: "ji-map-key-value", no: 569 },
      { id: "ji-map-entry-walk", no: 570 },
      { id: "ji-set-dedup", no: 571 },
      { id: "ji-collections-sort", no: 572 },
      { id: "ji-generic-box", no: 573 },
      { id: "ji-generic-method", no: 574 },
      { id: "ji-bounded-t", no: 575 },
      { id: "ji-wildcard-read-write", no: 576 },
      { id: "ji-pair-two-params", no: 577 },
      { id: "ji-catch-order", no: 578 },
      { id: "ji-throws-bubble", no: 579 },
      { id: "ji-custom-exception", no: 580 },
      { id: "ji-try-with-resources", no: 581 },
      { id: "ji-finally-always", no: 582 },
      { id: "ji-stream-lazy", no: 583 },
      { id: "ji-stream-filter", no: 584 },
      { id: "ji-stream-map-shape", no: 585 },
      { id: "ji-stream-reduce", no: 586 },
      { id: "ji-stream-collect", no: 587 },
      { id: "ji-stream-sorted", no: 588 },
      { id: "ji-stream-distinct", no: 589 },
      { id: "ji-limit-skip", no: 590 },
      { id: "ji-parallel-order", no: 591 },
      { id: "ji-lambda-shrink", no: 592 },
      { id: "ji-method-ref", no: 593 },
      { id: "ji-function-apply", no: 594 },
      { id: "ji-predicate-test", no: 595 },
      { id: "ji-consumer-supplier", no: 596 },
      { id: "ji-bifunction", no: 597 },
      { id: "ji-string-format", no: 598 },
      { id: "ji-stringbuilder", no: 599 },
      { id: "ji-regex-groups", no: 600 },
      { id: "ji-localdate-parts", no: 601 },
      { id: "ji-duration-between", no: 602 },
      { id: "ji-date-format-parse", no: 603 },
      { id: "ji-date-plus-minus", no: 604 },
      { id: "ji-files-write", no: 605 },
      { id: "ji-read-lines", no: 606 },
      { id: "ji-path-resolve", no: 607 },
      { id: "ji-buffered-stream", no: 608 },
      { id: "ji-file-exists", no: 609 },
      { id: "ji-extends-inherit", no: 610 },
      { id: "ji-super-call", no: 611 },
      { id: "ji-override-pick", no: 612 },
      { id: "ji-abstract-gate", no: 613 },
      { id: "ji-interface-contract", no: 614 },
      { id: "ji-default-method", no: 615 },
      { id: "ji-instanceof-pattern", no: 616 },
      { id: "ji-polymorphism-list", no: 617 },
      { id: "cb-hello-c", no: 618 },
      { id: "cb-compile-steps", no: 619 },
      { id: "cb-main-shape", no: 620 },
      { id: "cb-comment-scope", no: 621 },
      { id: "cb-error-line", no: 622 },
      { id: "cb-type-size", no: 623 },
      { id: "cb-printf-format", no: 624 },
      { id: "cb-scanf-input", no: 625 },
      { id: "cb-int-division", no: 626 },
      { id: "cb-cast-cut", no: 627 },
      { id: "cb-logic-ops", no: 628 },
      { id: "cb-if-block", no: 629 },
      { id: "cb-elseif-order", no: 630 },
      { id: "cb-switch-break", no: 631 },
      { id: "cb-ternary", no: 632 },
      { id: "cb-fizzbuzz-judge", no: 633 },
      { id: "cb-nested-cond", no: 634 },
      { id: "cb-for-parts", no: 635 },
      { id: "cb-while-cond", no: 636 },
      { id: "cb-do-while", no: 637 },
      { id: "cb-break-continue", no: 638 },
      { id: "cb-kuku-grid", no: 639 },
      { id: "cb-fizzbuzz-loop", no: 640 },
      { id: "cb-func-shape", no: 641 },
      { id: "cb-args-copy", no: 642 },
      { id: "cb-prototype", no: 643 },
      { id: "cb-void-func", no: 644 },
      { id: "cb-scope-c", no: 645 },
      { id: "cb-array-boxes", no: 646 },
      { id: "cb-array-loop", no: 647 },
      { id: "cb-array-sum", no: 648 },
      { id: "cb-array-maxmin", no: 649 },
      { id: "cb-string-nul", no: 650 },
      { id: "cb-string-funcs", no: 651 },
      { id: "cb-string-input", no: 652 },
      { id: "cb-address-of", no: 653 },
      { id: "cb-pointer-deref", no: 654 },
      { id: "cb-scanf-amp", no: 655 },
      { id: "cb-pointer-args", no: 656 },
      { id: "cb-array-decay", no: 657 },
      { id: "cb-struct-shape", no: 658 },
      { id: "cb-struct-member", no: 659 },
      { id: "cb-struct-array", no: 660 },
      { id: "cb-struct-func", no: 661 },
      { id: "cb-file-write", no: 662 },
      { id: "cb-file-read", no: 663 },
      { id: "cb-file-null", no: 664 },
      { id: "cb-menu-loop", no: 665 },
      { id: "c2-pointer-review", no: 666 },
      { id: "c2-pointer-arith", no: 667 },
      { id: "c2-array-duality", no: 668 },
      { id: "c2-pointer-walk", no: 669 },
      { id: "c2-string-pointers", no: 670 },
      { id: "c2-memory-layout", no: 671 },
      { id: "c2-stack-frames", no: 672 },
      { id: "c2-malloc-free", no: 673 },
      { id: "c2-memory-leak", no: 674 },
      { id: "c2-calloc-realloc", no: 675 },
      { id: "c2-strlen-impl", no: 676 },
      { id: "c2-strcpy-impl", no: 677 },
      { id: "c2-buffer-overflow", no: 678 },
      { id: "c2-string-parse", no: 679 },
      { id: "c2-dynamic-strings", no: 680 },
      { id: "c2-arrow-op", no: 681 },
      { id: "c2-dynamic-struct", no: 682 },
      { id: "c2-struct-array-dyn", no: 683 },
      { id: "c2-func-pointer", no: 684 },
      { id: "c2-qsort", no: 685 },
      { id: "c2-why-list", no: 686 },
      { id: "c2-node-define", no: 687 },
      { id: "c2-insert-head", no: 688 },
      { id: "c2-traverse-list", no: 689 },
      { id: "c2-insert-delete", no: 690 },
      { id: "c2-free-list", no: 691 },
      { id: "c2-dynamic-2d", no: 692 },
      { id: "c2-argv", no: 693 },
      { id: "c2-binary-files", no: 694 },
      { id: "c2-errno", no: 695 },
      { id: "c2-list-rebuild", no: 696 },
      { id: "c2-memory-debug", no: 697 },
      { id: "lx-everything-file", no: 698 },
      { id: "lx-view-contents", no: 699 },
      { id: "lx-create-files", no: 700 },
      { id: "lx-cp-command", no: 701 },
      { id: "lx-mv-command", no: 702 },
      { id: "lx-rm-command", no: 703 },
      { id: "lx-grep-basics", no: 704 },
      { id: "lx-grep-regex", no: 705 },
      { id: "lx-sed-basics", no: 706 },
      { id: "lx-awk-basics", no: 707 },
      { id: "lx-pipeline-practice", no: 708 },
      { id: "lx-why-linux", no: 709 },
      { id: "lx-shell-terminal", no: 710 },
      { id: "lx-first-commands", no: 711 },
      { id: "lx-find-command", no: 712 },
      { id: "lx-wildcards-glob", no: 713 },
      { id: "lx-compression", no: 714 },
      { id: "lx-file-attributes", no: 715 },
      { id: "lx-users-groups", no: 716 },
      { id: "lx-chmod-command", no: 717 },
      { id: "lx-chown-command", no: 718 },
      { id: "lx-executable-scripts", no: 719 },
      { id: "lx-what-is-process", no: 720 },
      { id: "lx-ps-command", no: 721 },
      { id: "lx-top-command", no: 722 },
      { id: "lx-foreground-bg", no: 723 },
      { id: "lx-nohup-persist", no: 724 },
      { id: "lx-network-basics", no: 725 },
      { id: "lx-curl-command", no: 726 },
      { id: "lx-network-info", no: 727 },
      { id: "lx-scp-command", no: 728 },
      { id: "lx-rsync-command", no: 729 },
      { id: "lx-what-is-env-var", no: 730 },
      { id: "lx-env-var-commands", no: 731 },
      { id: "lx-shell-config", no: 732 },
      { id: "lx-aliases", no: 733 },
      { id: "lx-what-is-script", no: 734 },
      { id: "lx-script-args", no: 735 },
      { id: "lx-script-if", no: 736 },
      { id: "lx-script-loops", no: 737 },
      { id: "lx-script-functions", no: 738 },
      { id: "lx-script-practical", no: 739 },
      { id: "lx-log-analysis", no: 740 },
      { id: "lx-system-info", no: 741 },
      { id: "lx-package-management", no: 742 },
      { id: "lx-cron-scheduling", no: 743 },
      { id: "lx-dev-environment", no: 744 },
      { id: "sv-how-web-serving", no: 745 },
      { id: "sv-install-nginx", no: 746 },
      { id: "sv-start-check", no: 747 },
      { id: "sv-document-root", no: 748 },
      { id: "sv-final-rebuild", no: 749 },
      { id: "sv-what-is-service", no: 750 },
      { id: "sv-systemctl-basics", no: 751 },
      { id: "sv-enable", no: 752 },
      { id: "sv-journalctl", no: 753 },
      { id: "sv-unit-file", no: 754 },
      { id: "sv-config-structure", no: 755 },
      { id: "sv-server-block", no: 756 },
      { id: "sv-location", no: 757 },
      { id: "sv-error-pages", no: 758 },
      { id: "sv-test-reload", no: 759 },
      { id: "sv-access-log", no: 760 },
      { id: "sv-dedicated-user", no: 761 },
      { id: "sv-ssh-keys", no: 762 },
      { id: "sv-sshd-config", no: 763 },
      { id: "sv-ufw", no: 764 },
      { id: "sv-ports-audit", no: 765 },
      { id: "sv-tls-basics", no: 766 },
      { id: "sv-self-signed", no: 767 },
      { id: "sv-nginx-https", no: 768 },
      { id: "sv-http-redirect", no: 769 },
      { id: "sv-tmux", no: 770 },
      { id: "sv-logrotate", no: 771 },
      { id: "sv-error-log", no: 772 },
      { id: "sv-healthcheck", no: 773 },
      { id: "sv-systemd-timer", no: 774 },
      { id: "sv-deploy-pattern", no: 775 },
      { id: "sv-symlink", no: 776 },
      { id: "sv-deploy-v2", no: 777 },
      { id: "sv-rollback", no: 778 },
      { id: "sv-final-incident", no: 779 },
      { id: "sb-intro-overview", no: 780 },
      { id: "sb-servlet-to-framework", no: 781 },
      { id: "sb-routing-table", no: 782 },
      { id: "sb-project-structure", no: 783 },
      { id: "sb-autoconfiguration", no: 784 },
      { id: "sb-path-matching", no: 785 },
      { id: "sb-why-di", no: 786 },
      { id: "sb-constructor-injection", no: 787 },
      { id: "sb-depend-on-interface", no: 788 },
      { id: "sb-component-and-bean", no: 789 },
      { id: "sb-mini-container", no: 790 },
      { id: "sb-bean-scope", no: 791 },
      { id: "sb-rest-principles", no: 792 },
      { id: "sb-restcontroller", no: 793 },
      { id: "sb-get-mapping", no: 794 },
      { id: "sb-request-param", no: 795 },
      { id: "sb-post-mapping", no: 796 },
      { id: "sb-status-codes", no: 797 },
      { id: "sb-response-entity", no: 798 },
      { id: "sb-json-binding", no: 799 },
      { id: "sb-dto-mapping", no: 800 },
      { id: "sb-record-dto", no: 801 },
      { id: "sb-validation-basic", no: 802 },
      { id: "sb-validation-errors", no: 803 },
      { id: "sb-validation-annotations", no: 804 },
      { id: "sb-layered-architecture", no: 805 },
      { id: "sb-service-layer", no: 806 },
      { id: "sb-state-transition", no: 807 },
      { id: "sb-business-rule", no: 808 },
      { id: "sb-transactional", no: 809 },
      { id: "sb-rollback-simulation", no: 810 },
      { id: "sb-jpa-entity", no: 811 },
      { id: "sb-repository-interface", no: 812 },
      { id: "sb-derived-query", no: 813 },
      { id: "sb-query-building", no: 814 },
      { id: "sb-paging-sorting", no: 815 },
      { id: "sb-n-plus-one", no: 816 },
      { id: "sb-exception-to-http", no: 817 },
      { id: "sb-controller-advice", no: 818 },
      { id: "sb-error-response", no: 819 },
      { id: "sb-filter-chain", no: 820 },
      { id: "sb-logging", no: 821 },
      { id: "sb-configuration-properties", no: 822 },
      { id: "sb-test-strategy", no: 823 },
      { id: "sb-unit-test", no: 824 },
      { id: "sb-mock-dependency", no: 825 },
      { id: "sb-mockmvc", no: 826 },
      { id: "gene-two-exams", no: 827 },
      { id: "gene-format-both", no: 828 },
      { id: "gene-study-plan", no: 829 },
      { id: "gene-format-trial", no: 830 },
      { id: "gene-what-is-ai", no: 831 },
      { id: "pe-ab-testing", no: 832 },
      { id: "pe-chain-of-thought", no: 833 },
      { id: "pe-constraints", no: 834 },
      { id: "pe-eval-metrics", no: 835 },
      { id: "pe-final-report", no: 836 },
      { id: "pe-improvement", no: 837 },
      { id: "pe-llm-basics", no: 838 },
      { id: "pe-persona", no: 839 },
      { id: "pe-react", no: 840 },
      { id: "pe-self-consistency", no: 841 },
      { id: "pe-tree-of-thoughts", no: 842 },
      { id: "pe-usecase-blog", no: 843 },
      { id: "pe-usecase-data", no: 844 },
      { id: "pe-usecase-support", no: 845 },
      { id: "pe-what-is-pe", no: 846 },
      { id: "pe-zero-shot", no: 847 },
      { id: "rg-chunking", no: 848 },
      { id: "rg-evaluation", no: 849 },
      { id: "rg-hallucination-fix", no: 850 },
      { id: "rg-improve-chunking", no: 851 },
      { id: "rg-improve-retrieval", no: 852 },
      { id: "rg-langchain", no: 853 },
      { id: "rg-production", no: 854 },
      { id: "rg-use-cases", no: 855 },
      { id: "rg-vector-db", no: 856 },
      { id: "rg-vector-search", no: 857 },
      { id: "rg-what-is-rag", no: 858 },
      { id: "cc-acceptance-criteria", no: 859 },
      { id: "cc-add-feature", no: 860 },
      { id: "cc-ask-about-code", no: 861 },
      { id: "cc-claude-md", no: 862 },
      { id: "cc-docs-gen", no: 863 },
      { id: "cc-explore-codebase", no: 864 },
      { id: "cc-final-bigfeature", no: 865 },
      { id: "cc-final-compare", no: 866 },
      { id: "cc-final-review", no: 867 },
      { id: "cc-first-instruction", no: 868 },
      { id: "cc-fix-bug", no: 869 },
      { id: "cc-fix-loop", no: 870 },
      { id: "cc-have-it-test", no: 871 },
      { id: "cc-how-it-works", no: 872 },
      { id: "cc-permissions-danger", no: 873 },
      { id: "cc-plan-first", no: 874 },
      { id: "cc-read-diffs", no: 875 },
      { id: "cc-read-generated", no: 876 },
      { id: "cc-refactor", no: 877 },
      { id: "cc-request-edit", no: 878 },
      { id: "cc-requirements", no: 879 },
      { id: "cc-run-and-verify", no: 880 },
      { id: "cc-setup-start", no: 881 },
      { id: "cc-split-tasks", no: 882 },
      { id: "cc-test-it", no: 883 },
      { id: "cc-undo-git", no: 884 },
      { id: "cc-what-is-agent", no: 885 },
      { id: "vc-be-specific", no: 886 },
      { id: "vc-behavior", no: 887 },
      { id: "vc-first-app", no: 888 },
      { id: "vc-fix-one-line", no: 889 },
      { id: "vc-idea-to-words", no: 890 },
      { id: "vc-iterate", no: 891 },
      { id: "vc-look-and-feel", no: 892 },
      { id: "vc-mobile", no: 893 },
      { id: "vc-paste-errors", no: 894 },
      { id: "vc-peek-at-code", no: 895 },
      { id: "vc-personalize", no: 896 },
      { id: "vc-polish", no: 897 },
      { id: "vc-re-explain", no: 898 },
      { id: "vc-share-publish", no: 899 },
      { id: "vc-small-changes", no: 900 },
      { id: "vc-step-by-step", no: 901 },
      { id: "vc-undo-restore", no: 902 },
      { id: "vc-what-is-vibe", no: 903 },
      { id: "vc-where-ai-fails", no: 904 },
      { id: "nd-async-review", no: 905 },
      { id: "nd-auth-concept", no: 906 },
      { id: "nd-db-connect", no: 907 },
      { id: "nd-dev-loop", no: 908 },
      { id: "nd-error-handling", no: 909 },
      { id: "nd-esm", no: 910 },
      { id: "nd-express-setup", no: 911 },
      { id: "nd-final-connect-react", no: 912 },
      { id: "nd-final-deploy", no: 913 },
      { id: "nd-fs", no: 914 },
      { id: "nd-get-detail", no: 915 },
      { id: "nd-get-list", no: 916 },
      { id: "nd-http-concept", no: 917 },
      { id: "nd-insert-api", no: 918 },
      { id: "nd-json-handling", no: 919 },
      { id: "nd-json-response", no: 920 },
      { id: "nd-login-token", no: 921 },
      { id: "nd-middleware", no: 922 },
      { id: "nd-npm-basics", no: 923 },
      { id: "nd-npm-scripts", no: 924 },
      { id: "nd-ownership", no: 925 },
      { id: "nd-package-json", no: 926 },
      { id: "nd-password-hash", no: 927 },
      { id: "nd-post", no: 928 },
      { id: "nd-protected-routes", no: 929 },
      { id: "nd-put-delete", no: 930 },
      { id: "nd-query-params", no: 931 },
      { id: "nd-rest-concept", no: 932 },
      { id: "nd-routing", no: 933 },
      { id: "nd-run-node", no: 934 },
      { id: "nd-select-api", no: 935 },
      { id: "nd-sort-paging", no: 936 },
      { id: "nd-sql-injection", no: 937 },
      { id: "nd-status-codes", no: 938 },
      { id: "nd-transaction-buy", no: 939 },
      { id: "nd-update-delete-api", no: 940 },
      { id: "nd-validation", no: 941 },
      { id: "nd-what-is-node", no: 942 },
      { id: "go-append-slices", no: 943 },
      { id: "go-arrays-go", no: 944 },
      { id: "go-basic-types", no: 945 },
      { id: "go-channels", no: 946 },
      { id: "go-compile-build", no: 947 },
      { id: "go-concurrency-care", no: 948 },
      { id: "go-constants", no: 949 },
      { id: "go-constructor-func", no: 950 },
      { id: "go-creating-errors", no: 951 },
      { id: "go-defer", no: 952 },
      { id: "go-error-handling", no: 953 },
      { id: "go-final-deploy", no: 954 },
      { id: "go-final-swap", no: 955 },
      { id: "go-fizzbuzz-go", no: 956 },
      { id: "go-for-only", no: 957 },
      { id: "go-for-patterns", no: 958 },
      { id: "go-functions", no: 959 },
      { id: "go-get-detail", no: 960 },
      { id: "go-get-list", no: 961 },
      { id: "go-goroutines", no: 962 },
      { id: "go-handlers", no: 963 },
      { id: "go-if-go", no: 964 },
      { id: "go-json-encode", no: 965 },
      { id: "go-loop-aggregate", no: 966 },
      { id: "go-main-package", no: 967 },
      { id: "go-map-exists", no: 968 },
      { id: "go-maps", no: 969 },
      { id: "go-methods", no: 970 },
      { id: "go-multiple-returns", no: 971 },
      { id: "go-net-http", no: 972 },
      { id: "go-no-implicit-cast", no: 973 },
      { id: "go-pointer-receivers", no: 974 },
      { id: "go-post-create", no: 975 },
      { id: "go-println-fmt", no: 976 },
      { id: "go-range", no: 977 },
      { id: "go-routing", no: 978 },
      { id: "go-run-go", no: 979 },
      { id: "go-short-declare", no: 980 },
      { id: "go-slices", no: 981 },
      { id: "go-struct-init", no: 982 },
      { id: "go-struct-slices", no: 983 },
      { id: "go-structs", no: 984 },
      { id: "go-switch-go", no: 985 },
      { id: "go-var-declare", no: 986 },
      { id: "go-waitgroup", no: 987 },
      { id: "go-what-is-go", no: 988 },
      { id: "dojo-go-01", no: 989 },
      { id: "dojo-go-03", no: 990 },
      { id: "dojo-go-04", no: 991 },
      { id: "dojo-go-05", no: 992 },
      { id: "dojo-go-06", no: 993 },
      { id: "dojo-go-07", no: 994 },
      { id: "dojo-go-08", no: 995 },
      { id: "dojo-go-09", no: 996 },
      { id: "dojo-java-01", no: 997 },
      { id: "dojo-java-02", no: 998 },
      { id: "dojo-java-03", no: 999 },
      { id: "anchor-jump-id", no: 1000 },
      { id: "attr-name-value", no: 1001 },
      { id: "audit-three-points", no: 1002 },
      { id: "auto-rows-minmax", no: 1003 },
      { id: "bit-mask", no: 1004 },
      { id: "block-inline-flow", no: 1005 },
      { id: "border-three-values", no: 1006 },
      { id: "box-model-layers", no: 1007 },
      { id: "box-sizing-width", no: 1008 },
      { id: "breakpoint-missing-rule", no: 1009 },
      { id: "card-audit-check", no: 1010 },
      { id: "card-base-stack", no: 1011 },
      { id: "class-id-target", no: 1012 },
      { id: "color-notation-swatch", no: 1013 },
      { id: "comment-hide-toggle", no: 1014 },
      { id: "css-link-connect", no: 1015 },
      { id: "css-style-on-off", no: 1016 },
      { id: "div-span-flow", no: 1017 },
      { id: "dojo-java-04", no: 1018 },
      { id: "dom-text-rewrite", no: 1019 },
      { id: "flex-align-cross", no: 1020 },
      { id: "flex-container-item", no: 1021 },
      { id: "flex-direction-wrap", no: 1022 },
      { id: "flex-grow-share", no: 1023 },
      { id: "flex-justify-main", no: 1024 },
      { id: "flex-or-grid-pick", no: 1025 },
      { id: "git-merge-shape", no: 1026 },
      { id: "git-reset-modes", no: 1027 },
      { id: "grid-double-gap", no: 1028 },
      { id: "grid-span-cells", no: 1029 },
      { id: "grid-template-tracks", no: 1030 },
      { id: "heading-outline", no: 1031 },
      { id: "hover-state-swap", no: 1032 },
      { id: "html-head-body", no: 1033 },
      { id: "html-skeleton-head", no: 1034 },
      { id: "html-tag-meaning", no: 1035 },
      { id: "img-alt-fallback", no: 1036 },
      { id: "label-for-id", no: 1037 },
      { id: "margin-padding-diff", no: 1038 },
      { id: "media-breakpoint", no: 1039 },
      { id: "mobile-first-order", no: 1040 },
      { id: "nav-flex-cleanup", no: 1041 },
      { id: "p-br-wrap", no: 1042 },
      { id: "page-audit-check", no: 1043 },
      { id: "palette-role-check", no: 1044 },
      { id: "publish-file-url", no: 1045 },
      { id: "section-tag-pick", no: 1046 },
      { id: "selector-target-scope", no: 1047 },
      { id: "semantic-header-main", no: 1048 },
      { id: "shadow-offset-blur", no: 1049 },
      { id: "spacing-scale-tidy", no: 1050 },
      { id: "specificity-contest", no: 1051 },
      { id: "sql-delete-scope", no: 1052 },
      { id: "sql-first-normal-form", no: 1053 },
      { id: "sql-insert-columns-values", no: 1054 },
      { id: "sql-query-roundtrip", no: 1055 },
      { id: "sql-update-where-scope", no: 1056 },
      { id: "strong-b-meaning", no: 1057 },
      { id: "table-row-cell", no: 1058 },
      { id: "tag-close-pair", no: 1059 },
      { id: "text-size-lineheight", no: 1060 },
      { id: "transition-duration-feel", no: 1061 },
      { id: "trust-client-price", no: 1062 },
      { id: "truth-table", no: 1063 },
      { id: "ul-ol-switch", no: 1064 },
      { id: "unit-width-resize", no: 1065 },
      { id: "viewport-meta-scale", no: 1066 },
      { id: "viewport-overflow-scroll", no: 1067 },
      { id: "webfont-fallback-chain", no: 1068 },
      { id: "width-percent-px", no: 1069 },
      { id: "dojo-java-05", no: 1070 },
      { id: "dojo-java-06", no: 1071 },
      { id: "dojo-java-07", no: 1072 },
      { id: "dojo-java-08", no: 1073 },
      { id: "dojo-java-09", no: 1074 },
      { id: "dojo-java-10", no: 1075 },
      { id: "dojo-js-01", no: 1076 },
      { id: "dojo-js-02", no: 1077 },
      { id: "dojo-js-03", no: 1078 },
      { id: "dojo-js-04", no: 1079 },
      { id: "dojo-js-05", no: 1080 },
      { id: "dojo-js-06", no: 1081 },
      { id: "dojo-js-07", no: 1082 },
      { id: "dojo-js-08", no: 1083 },
      { id: "dojo-js-09", no: 1084 },
      { id: "dojo-js-10", no: 1085 },
      { id: "dojo-py-01", no: 1086 },
      { id: "dojo-py-02", no: 1087 },
      { id: "dojo-py-03", no: 1088 },
      { id: "dojo-py-04", no: 1089 },
      { id: "dojo-py-05", no: 1090 },
      { id: "dojo-py-06", no: 1091 },
      { id: "dojo-py-07", no: 1092 },
      { id: "dojo-py-08", no: 1093 },
      { id: "dojo-py-09", no: 1094 },
      { id: "dojo-py-10", no: 1095 },
      { id: "dojo-re-01", no: 1096 },
      { id: "dojo-re-02", no: 1097 },
      { id: "dojo-re-03", no: 1098 },
      { id: "dojo-re-04", no: 1099 },
      { id: "dojo-re-05", no: 1100 },
      { id: "dojo-re-06", no: 1101 },
      { id: "dojo-re-07", no: 1102 },
      { id: "dojo-re-08", no: 1103 },
      { id: "dojo-re-09", no: 1104 },
      { id: "dojo-re-10", no: 1105 },
      { id: "dojo-sql-01", no: 1106 },
      { id: "dojo-al-01", no: 1107 },
      { id: "alg-anagram-group", no: 1108 },
      { id: "net-cdn", no: 1109 },
      { id: "net-dns-cache", no: 1110 },
      { id: "net-dns-intro", no: 1111 },
      { id: "net-dns-records", no: 1112 },
      { id: "net-grpc", no: 1113 },
      { id: "net-http2-http3", no: 1114 },
      { id: "net-ip-address", no: 1115 },
      { id: "net-osi-model", no: 1116 },
      { id: "net-proxy", no: 1117 },
      { id: "net-rest-api", no: 1118 },
      { id: "net-router-switch", no: 1119 },
      { id: "net-subnet", no: 1120 },
      { id: "net-tcp-congestion", no: 1121 },
      { id: "net-tcp-handshake", no: 1122 },
      { id: "net-tcpip-model", no: 1123 },
      { id: "net-udp-use-cases", no: 1124 },
      { id: "net-websocket", no: 1125 },
      { id: "net-what-is", no: 1126 },
      { id: "os-async", no: 1127 },
      { id: "os-context-switch", no: 1128 },
      { id: "os-deadlock", no: 1129 },
      { id: "os-filesystem", no: 1130 },
      { id: "os-fs-types", no: 1131 },
      { id: "os-history", no: 1132 },
      { id: "os-inode", no: 1133 },
      { id: "os-io", no: 1134 },
      { id: "os-ipc", no: 1135 },
      { id: "os-kernel-userland", no: 1136 },
      { id: "os-mmap", no: 1137 },
      { id: "os-mutex", no: 1138 },
      { id: "os-paging", no: 1139 },
      { id: "os-permissions", no: 1140 },
      { id: "os-popular-os", no: 1141 },
      { id: "os-process", no: 1142 },
      { id: "os-race-condition", no: 1143 },
      { id: "os-system-call", no: 1144 },
      { id: "os-thread", no: 1145 },
      { id: "os-what-is", no: 1146 },
      { id: "alg-binary-search-iter", no: 1147 },
      { id: "alg-binary-search-rec", no: 1148 },
      { id: "alg-bubble-sort", no: 1149 },
      { id: "alg-class-bst-insert", no: 1150 },
      { id: "alg-class-counter", no: 1151 },
      { id: "alg-class-queue", no: 1152 },
      { id: "alg-class-rect", no: 1153 },
      { id: "alg-class-stack", no: 1154 },
      { id: "alg-climb-stairs", no: 1155 },
      { id: "alg-coin-change", no: 1156 },
      { id: "alg-count-digits", no: 1157 },
      { id: "alg-counting-sort", no: 1158 },
      { id: "alg-fib-dp", no: 1159 },
      { id: "alg-fib-memo", no: 1160 },
      { id: "alg-fibonacci", no: 1161 },
      { id: "alg-find-peak", no: 1162 },
      { id: "alg-gcd-euclidean", no: 1163 },
      { id: "alg-insertion-sort", no: 1164 },
      { id: "alg-int-to-roman", no: 1165 },
      { id: "alg-knapsack-01", no: 1166 },
      { id: "alg-lcs", no: 1167 },
      { id: "alg-linear-search-index", no: 1168 },
      { id: "alg-longest-substr", no: 1169 },
      { id: "alg-lower-bound", no: 1170 },
      { id: "alg-merge-sort", no: 1171 },
      { id: "alg-merge-sorted", no: 1172 },
      { id: "alg-palindrome-check", no: 1173 },
      { id: "alg-power", no: 1174 },
      { id: "alg-reverse-string", no: 1175 },
      { id: "alg-roman-to-int", no: 1176 },
      { id: "alg-rotate-array", no: 1177 },
      { id: "alg-rotated-search", no: 1178 },
      { id: "alg-selection-sort", no: 1179 },
      { id: "alg-sort-by-key", no: 1180 },
      { id: "alg-string-multiply", no: 1181 },
      { id: "alg-sum-recursive", no: 1182 },
      { id: "alg-trap-water", no: 1183 },
      { id: "alg-two-pointer-pair", no: 1184 },
      { id: "alg-validate-paren", no: 1185 },
      { id: "dojo-al-02", no: 1186 },
      { id: "dojo-al-03", no: 1187 },
      { id: "dojo-al-04", no: 1188 },
      { id: "dojo-al-05", no: 1189 },
      { id: "dojo-al-06", no: 1190 },
      { id: "dojo-al-07", no: 1191 },
      { id: "dojo-al-09", no: 1192 },
      { id: "dojo-ex-01", no: 1193 },
      { id: "dojo-ex-02", no: 1194 },
      { id: "dojo-ex-03", no: 1195 },
      { id: "dojo-ex-04", no: 1196 },
      { id: "dojo-ex-06", no: 1197 },
      { id: "dojo-ex-07", no: 1198 },
      { id: "dojo-ex-10", no: 1199 },
      { id: "dojo-fd-01", no: 1200 },
      { id: "dojo-fd-02", no: 1201 },
      { id: "dojo-fd-03", no: 1202 },
      { id: "dojo-fd-04", no: 1203 },
      { id: "dojo-fd-06", no: 1204 },
      { id: "dojo-fd-07", no: 1205 },
      { id: "dojo-fd-08", no: 1206 },
      { id: "dojo-fd-09", no: 1207 },
      { id: "dojo-hc-01", no: 1208 },
      { id: "dojo-hc-02", no: 1209 },
      { id: "dojo-hc-03", no: 1210 },
      { id: "dojo-hc-04", no: 1211 },
      { id: "dojo-hc-05", no: 1212 },
      { id: "dojo-hc-06", no: 1213 },
      { id: "dojo-hc-07", no: 1214 },
      { id: "dojo-hc-08", no: 1215 },
      { id: "dojo-hc-09", no: 1216 },
      { id: "dojo-lx-01", no: 1217 },
      { id: "dojo-lx-02", no: 1218 },
      { id: "dojo-lx-03", no: 1219 },
      { id: "dojo-lx-04", no: 1220 },
      { id: "dojo-lx-05", no: 1221 },
      { id: "dojo-lx-07", no: 1222 },
      { id: "dojo-lx-08", no: 1223 },
      { id: "dojo-lx-09", no: 1224 },
      { id: "dojo-lx-10", no: 1225 },
      { id: "dojo-pr-01", no: 1226 },
      { id: "dojo-pr-03", no: 1227 },
      { id: "dojo-pr-08", no: 1228 },
      { id: "dojo-pr-09", no: 1229 },
      { id: "dojo-sql-02", no: 1230 },
      { id: "dojo-sql-03", no: 1231 },
      { id: "dojo-sql-05", no: 1232 },
      { id: "dojo-sql-07", no: 1233 },
      { id: "dojo-sql-08", no: 1234 },
      { id: "dojo-sql-09", no: 1235 },
      { id: "dojo-sql-10", no: 1236 },
      { id: "dojo-ts-01", no: 1237 },
      { id: "dojo-ts-03", no: 1238 },
      { id: "dojo-ts-04", no: 1239 },
      { id: "dojo-ts-07", no: 1240 },
      { id: "dojo-ts-08", no: 1241 },
      { id: "dojo-ts-09", no: 1242 },
      { id: "dojo-ts-10", no: 1243 },
      { id: "go-zero-values", no: 1244 },
      { id: "gene-ai-history", no: 1245 },
      { id: "gene-ml-types", no: 1246 },
      { id: "gene-nn-dl-basics", no: 1247 },
      { id: "gene-evaluation-overfit", no: 1248 },
      { id: "gene-regression-classification", no: 1249 },
      { id: "gene-trees-ensemble", no: 1250 },
      { id: "gene-clustering-dimred", no: 1251 },
      { id: "gene-llm-basics", no: 1252 },
      { id: "gene-image-generation", no: 1253 },
      { id: "gene-multimodal", no: 1254 },
      { id: "gene-rag-exam", no: 1255 },
      { id: "gene-finetune-concepts", no: 1256 },
      { id: "gene-business-usecases", no: 1257 },
      { id: "gene-prompt-exam", no: 1258 },
      { id: "gene-ai-services-map", no: 1259 },
      { id: "gene-trends", no: 1260 },
      { id: "gene-hallucination-risks", no: 1261 },
      { id: "gene-copyright-ai", no: 1262 },
      { id: "gene-personal-data-ai", no: 1263 },
      { id: "gene-security-ai", no: 1264 },
      { id: "gene-governance-guidelines", no: 1265 },
      { id: "gene-bias-ethics", no: 1266 },
      { id: "gene-gradient-descent", no: 1267 },
      { id: "gene-regularization", no: 1268 },
      { id: "gene-cnn", no: 1269 },
      { id: "gene-rnn-attention", no: 1270 },
      { id: "gene-transformer-exam", no: 1271 },
      { id: "gene-generative-models", no: 1272 },
      { id: "gene-reinforcement", no: 1273 },
      { id: "gene-dl-history-people", no: 1274 },
      { id: "db-what-is", no: 1275 },
      { id: "db-rdb-vs-nosql", no: 1276 },
      { id: "db-history", no: 1277 },
      { id: "db-er-model", no: 1278 },
      { id: "db-keys", no: 1279 },
      { id: "db-normalization-intro", no: 1280 },
      { id: "db-1nf", no: 1281 },
      { id: "db-2nf", no: 1282 },
      { id: "db-3nf", no: 1283 },
      { id: "db-denormalization", no: 1284 },
      { id: "db-btree", no: 1285 },
      { id: "db-bptree", no: 1286 },
      { id: "db-covering-index", no: 1287 },
      { id: "db-transaction-intro", no: 1288 },
      { id: "db-acid", no: 1289 },
      { id: "db-isolation-levels", no: 1290 },
      { id: "db-mvcc", no: 1291 },
      { id: "db-deadlock", no: 1292 },
      { id: "db-query-planner", no: 1293 },
      { id: "db-explain", no: 1294 },
      { id: "db-join-types", no: 1295 },
      { id: "db-index-tuning", no: 1296 },
      { id: "db-stats-cardinality", no: 1297 },
      { id: "db-replication", no: 1298 },
      { id: "db-sharding", no: 1299 },
      { id: "db-cap-theorem", no: 1300 },
      { id: "db-eventual-consistency", no: 1301 },
      { id: "db-newsql", no: 1302 },
      { id: "sd-ll-build", no: 1303 },
      { id: "sd-ll-reverse", no: 1304 },
      { id: "sd-ll-cycle", no: 1305 },
      { id: "sd-ll-merge", no: 1306 },
      { id: "sd-ll-middle", no: 1307 },
      { id: "sd-ll-remove-duplicates", no: 1308 },
      { id: "sd-tree-inorder", no: 1309 },
      { id: "sd-tree-preorder", no: 1310 },
      { id: "sd-tree-postorder", no: 1311 },
      { id: "sd-tree-height", no: 1312 },
      { id: "sd-tree-balanced", no: 1313 },
      { id: "sd-bst-insert", no: 1314 },
      { id: "sd-bst-search", no: 1315 },
      { id: "sd-bst-min-max", no: 1316 },
      { id: "sd-bst-validate", no: 1317 },
      { id: "sd-bst-kth-smallest", no: 1318 },
      { id: "sd-bst-delete", no: 1319 },
      { id: "sd-hash-frequency", no: 1320 },
      { id: "sd-hash-group-by", no: 1321 },
      { id: "sd-hash-two-sum", no: 1322 },
      { id: "sd-hash-subarray-sum", no: 1323 },
      { id: "sd-hash-longest-consec", no: 1324 },
      { id: "sd-set-intersection", no: 1325 },
      { id: "sd-graph-bfs", no: 1326 },
      { id: "sd-graph-dfs", no: 1327 },
      { id: "sd-graph-path-exists", no: 1328 },
      { id: "sd-graph-shortest-bfs", no: 1329 },
      { id: "sd-graph-topo-sort", no: 1330 },
      { id: "sd-graph-bipartite", no: 1331 },
      { id: "sd-graph-dijkstra", no: 1332 },
      { id: "sd-dp-edit-distance", no: 1333 },
      { id: "sd-dp-longest-increasing", no: 1334 },
      { id: "sd-dp-max-subarray", no: 1335 },
      { id: "sd-dp-house-robber", no: 1336 },
      { id: "sd-dp-unique-paths", no: 1337 },
      { id: "sd-dp-word-break", no: 1338 },
      { id: "sd-fp-map-filter", no: 1339 },
      { id: "sd-fp-reduce-product", no: 1340 },
      { id: "sd-fp-compose", no: 1341 },
      { id: "sd-fp-curry", no: 1342 },
      { id: "sd-trie-search", no: 1343 },
      { id: "sd-union-find", no: 1344 },
      { id: "cs-dec-to-bin", no: 1345 },
      { id: "cs-bit-and", no: 1346 },
      { id: "cs-bit-or-xor", no: 1347 },
      { id: "cs-popcount", no: 1348 },
      { id: "cs-hex-conversion", no: 1349 },
      { id: "cs-code-to-char", no: 1350 },
      { id: "cs-logical-not-xor", no: 1351 },
      { id: "cs-de-morgan", no: 1352 },
      { id: "cs-count-iterations", no: 1353 },
      { id: "cs-linear-search", no: 1354 },
      { id: "cs-set-unique", no: 1355 },
      { id: "cs-anagram-check", no: 1356 },
      { id: "cs-byte-to-kb", no: 1357 },
      { id: "cs-disk-size-format", no: 1358 },
      { id: "cs-page-replace-lru", no: 1359 },
      { id: "cs-buffer-overflow", no: 1360 },
      { id: "cs-base64-length", no: 1361 },
      { id: "cs-url-encode-count", no: 1362 },
      { id: "cs-ip-to-int", no: 1363 },
      { id: "cs-int-to-ip", no: 1364 },
      { id: "cs-checksum-sum", no: 1365 },
      { id: "cs-foreign-key-join", no: 1366 },
      { id: "cs-cap-availability", no: 1367 },
      { id: "cs-mvc-route", no: 1368 },
      { id: "da-what-is-analysis", no: 1369 },
      { id: "da-why-pandas", no: 1370 },
      { id: "da-notebook-basics", no: 1371 },
      { id: "da-read-csv", no: 1372 },
      { id: "da-series-dataframe", no: 1373 },
      { id: "da-head-info", no: 1374 },
      { id: "da-select-columns", no: 1375 },
      { id: "da-loc-iloc", no: 1376 },
      { id: "da-filter-rows", no: 1377 },
      { id: "da-multi-conditions", no: 1378 },
      { id: "da-sort-values", no: 1379 },
      { id: "da-detect-missing", no: 1380 },
      { id: "da-handle-missing", no: 1381 },
      { id: "da-type-conversion", no: 1382 },
      { id: "da-duplicates", no: 1383 },
      { id: "da-string-cleaning", no: 1384 },
      { id: "da-to-datetime", no: 1385 },
      { id: "da-aggregate-basics", no: 1386 },
      { id: "da-groupby", no: 1387 },
      { id: "da-groupby-multi", no: 1388 },
      { id: "da-agg", no: 1389 },
      { id: "da-pivot-table", no: 1390 },
      { id: "da-value-counts", no: 1391 },
      { id: "da-why-merge", no: 1392 },
      { id: "da-merge", no: 1393 },
      { id: "da-concat", no: 1394 },
      { id: "da-matplotlib-basics", no: 1395 },
      { id: "da-bar-chart", no: 1396 },
      { id: "da-line-chart", no: 1397 },
      { id: "da-histogram", no: 1398 },
      { id: "da-multi-series", no: 1399 },
      { id: "da-labels-titles", no: 1400 },
      { id: "da-asking-questions", no: 1401 },
      { id: "da-mom-growth", no: 1402 },
      { id: "da-moving-average", no: 1403 },
      { id: "da-composition", no: 1404 },
      { id: "da-outliers", no: 1405 },
    ],
  },
];
